const types = {
    SET_LIST_CREDIT_HISTORY: '[CREDIT] SET LIST CREDIT HISTORY',
}

export {
    types
}